import React from 'react';
import { Subheading } from '../../common/TextComponents';

const BentoCard = ({
  dark = false,
  className = '',
  eyebrow,
  title,
  description,
  graphic,
  fade = [],
}) => {
  return (
    <div
      className={`group relative flex flex-col overflow-hidden rounded-xl shadow-lg transition-all duration-200 hover:shadow-xl ${
        dark 
          ? 'bg-gray-800/90 backdrop-blur-sm ring-1 ring-gray-700/50 hover:ring-gray-600/50' 
          : 'bg-white/90 backdrop-blur-sm ring-1 ring-gray-200/50 hover:ring-gray-300/50'
      } ${className}`}
    >
      {/* <div className="relative h-80 shrink-0">
        {graphic}
        {fade.includes('top') && (
          <div className={`absolute inset-0 bg-gradient-to-b ${dark ? 'from-gray-800 from-[-25%]' : 'from-white'} to-50%`} />
        )}
        {fade.includes('bottom') && (
          <div className={`absolute inset-0 bg-gradient-to-t ${dark ? 'from-gray-800 from-[-25%]' : 'from-white'} to-50%`} />
        )}
      </div> */}
      <div className="relative p-8">
        <div className="mb-4">
          {eyebrow}
        </div>
        <h3 className={`text-xl font-semibold tracking-tight mb-3 ${
          dark ? 'text-white' : 'text-gray-900'
        }`}>
          {title}
        </h3>
        <p className={`text-sm leading-relaxed ${
          dark ? 'text-gray-300' : 'text-gray-600'
        }`}>
          {description}
        </p>
      </div>
    </div>
  );
};

export default BentoCard;